import React from 'react';
import { Link } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';
import CopyButton from './CopyButton';
import * as FiIcons from 'react-icons/fi';

const { FiCheckCircle, FiXCircle, FiExternalLink } = FiIcons;

const ProductListItem = ({ product, visibleColumns, allFields }) => {
  const renderCellContent = (field, value) => {
    if (field.includes('Enabled')) {
      const isEnabled = value === 'TRUE' || value === '1' || value === true;
      return (
        <div className={`flex items-center gap-1.5 font-medium ${isEnabled ? 'text-emerald-600 dark:text-emerald-400' : 'text-gray-300 dark:text-gray-700'}`}>
          <SafeIcon icon={isEnabled ? FiCheckCircle : FiXCircle} className="text-xs" />
          <span className="text-[10px] uppercase tracking-tight">{isEnabled ? 'Yes' : 'No'}</span>
        </div>
      );
    }
    
    if (field.includes('URL') && value) {
      return (
        <a href={value} target="_blank" rel="noopener noreferrer" className="text-blue-500 dark:text-blue-400 hover:text-blue-700 flex items-center gap-1 text-xs" onClick={(e) => e.stopPropagation()}>
          View <SafeIcon icon={FiExternalLink} className="text-[10px]" />
        </a>
      );
    }

    if (field === 'SitePrice' || field === 'SiteCost') {
      return <span className="font-medium text-gray-900 dark:text-gray-100 font-mono">${(parseFloat(value) || 0).toFixed(2)}</span>;
    }

    if (field === 'AggregateQty') {
      const qty = parseInt(value) || 0;
      return (
        <div className="flex items-center gap-2">
          <span className={`w-1.5 h-1.5 rounded-full ${qty > 10 ? 'bg-emerald-500' : qty > 0 ? 'bg-amber-500' : 'bg-rose-500'}`} />
          <span className="font-mono text-gray-700 dark:text-gray-300">{qty}</span>
        </div>
      );
    }

    if (field === 'Location' || field === 'UPC') {
      return (
        <div className="flex items-center gap-1 group/cell">
          <span className="text-gray-600 dark:text-gray-400 truncate max-w-[150px]">{value || '—'}</span>
          {value && <CopyButton text={value} className="opacity-0 group-hover/cell:opacity-100" />}
        </div>
      );
    }

    return <span className="text-gray-600 dark:text-gray-400 truncate max-w-[200px] inline-block">{value || '—'}</span>;
  };

  return (
    <tr className="group hover:bg-gray-50/80 dark:hover:bg-gray-800/80 transition-colors">
      <td className="py-3 px-4 sticky left-0 bg-white dark:bg-gray-900 group-hover:bg-gray-50 dark:group-hover:bg-gray-800 group-hover:z-20 transition-colors border-r border-transparent group-hover:border-gray-100 dark:group-hover:border-gray-700">
        <div className="flex items-center gap-3 min-w-[240px]">
          <Link to={`/product/${encodeURIComponent(product.id)}`} className="h-9 w-9 rounded overflow-hidden bg-gray-50 dark:bg-gray-800 shrink-0 border border-gray-100 dark:border-gray-700 flex items-center justify-center p-0.5">
            <img src={product.image || 'https://via.placeholder.com/100?text=No+Img'} alt="" className="max-w-full max-h-full object-contain" />
          </Link>
          <div className="min-w-0">
            <Link to={`/product/${encodeURIComponent(product.id)}`} className="text-xs font-medium text-gray-900 dark:text-white truncate block hover:text-blue-600 dark:hover:text-blue-400 transition-colors">
              {product.title || 'Unknown Product'}
            </Link>
            <div className="flex items-center gap-1 group/sku mt-0.5">
              <p className="text-[9px] text-gray-400 dark:text-gray-500 font-mono uppercase tracking-tighter">{product.sku}</p>
              <CopyButton text={product.sku} className="opacity-0 group-hover/sku:opacity-100 !p-0" />
            </div>
          </div>
        </div>
      </td>
      
      {allFields.filter(f => f !== 'ProductName' && visibleColumns[f]).map(field => (
        <td key={field} className="py-3 px-4 text-xs whitespace-nowrap">
          {renderCellContent(field, product[field])}
        </td>
      ))}
    </tr>
  );
};

export default ProductListItem;